import { useMemo } from 'react';
import { buildReadOnlyPrivilegesData } from '../../utils/privilegesUtils';

const useReadOnlyPrivileges = (rawPrivileges) => {
  const data = useMemo(
    () =>
      rawPrivileges && rawPrivileges.length > 0
        ? buildReadOnlyPrivilegesData(rawPrivileges)
        : null,
    [rawPrivileges]
  );

  return data;
};

export default useReadOnlyPrivileges;
